import { genView } from "./colleges.ts";

export default genView("state");
